export const STYLE_STORE = 'STYLE_STORE';
export const STYLE_UPDATE = 'STYLE_UPDATE';
export const STYLE_DESTROY = 'STYLE_DESTROY';
